import React from "react"
import { Card, Media } from "react-bootstrap"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ImageFluid from "../../components/misc/image-fluid";
import { injectIntl, Link } from "gatsby-plugin-react-intl";
import SmallAvatar from "./small-avatar"

function BlogCard ({ intl, content }) {
  return (
    <div className={`blog-card`}>
      <Card>
        <Link className={`card-button`} to={content.button.url}>
          {content.header &&
          <Card.Header>{content.header}</Card.Header>
          }
          {content.image &&
          <div className={`card-image`}>
            <ImageFluid alt={content.title} filename={content.image} />
          </div>
          }
          <Card.Body>
            {content.postInfo &&
            <Media>
              <div className={`avatar`}>
                <SmallAvatar alt={content.postInfo.author} filename={`authors/` + content.postInfo.author + `.png`} />
              </div>
              <Media.Body>
                <div className={`author`}>{content.postInfo.author}</div>
                <div className={`date`}>{content.postInfo.date}</div>
                <div className={`tags`}>{intl.formatMessage({id : "pages.blog.postTags"})} {intl.formatMessage({id : "pages.blog.tag-" + content.postInfo.tags})}</div>
              </Media.Body>
            </Media>
            }
            {content.title &&
            <Card.Title>{content.title}</Card.Title>
            }
            {content.text &&
            <Card.Text dangerouslySetInnerHTML={{__html: content.text}}></Card.Text>
            }
            {content.button &&
            <div className={`button`}>{content.button.label} <FontAwesomeIcon icon="arrow-right" /></div>
            }
          </Card.Body>
        </Link>
      </Card>
    </div>
  )
}

export default injectIntl(BlogCard)
